/**
 * This file kicks off VITEJS tasks to minify and compile CSS and JS.
 */
const flame = String.fromCodePoint(0x1f525)

// CSS imports
import './assets/css/main.css'

// JS imports
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import focus from '@alpinejs/focus'
import validate from '@colinaut/alpinejs-plugin-simple-validate'
import collapse from '@alpinejs/collapse'
import './assets/js/_obaia-window-helpers'
import './assets/js/_obaia-window-components'

Alpine.plugin(focus)
Alpine.plugin(intersect)
Alpine.plugin(validate)
Alpine.plugin(collapse)
Alpine.start()

// * END OF FILE
console.log(`%c
            
            ` + flame + ` Made with a keyboard by ` + flame + `

 ________      ________      ________      ___      ________     
|\\   __  \\    |\\   __  \\    |\\   __  \\    |\\  \\    |\\   __  \\    
\\ \\  \\|\\  \\   \\ \\  \\|\\ /_   \\ \\  \\|\\  \\   \\ \\  \\   \\ \\  \\|\\  \\   
 \\ \\  \\\\\\  \\   \\ \\   __  \\   \\ \\   __  \\   \\ \\  \\   \\ \\   __  \\  
  \\ \\  \\\\\\  \\   \\ \\  \\|\\  \\   \\ \\  \\ \\  \\   \\ \\  \\   \\ \\  \\ \\  \\ 
   \\ \\_______\\   \\ \\_______\\   \\ \\__\\ \\__\\   \\ \\__\\   \\ \\__\\ \\__\\
    \\|_______|    \\|_______|    \\|__|\\|__|    \\|__|    \\|__|\\|__|


                            WEBDEVELOPMENT
                            https://obaia.nl

`, `font-family: monospace;`)